/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FuturesContractsSummaryResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class RefFuturesContractsSummaries<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetFuturesContractsSummary
   * @request GET:/refFuturesContracts-summaries
   * @secure
   */
  getFuturesContractsSummary = (
    query?: {
      includeInactive?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<FuturesContractsSummaryResponse, any>({
      path: `/refFuturesContracts-summaries`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsRefFuturesContractsSummaries
   * @request OPTIONS:/refFuturesContracts-summaries
   */
  optionsRefFuturesContractsSummaries = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/refFuturesContracts-summaries`,
      method: 'OPTIONS',
      ...params,
    });
}
